import Vue from 'vue';
import recipeProcedureTransformer from '../../transformers/recipeProcedure';
import store from '../../store';

const success = (resolve, response) => {
  store.dispatch('updateRecipeProcedure', {
    recipeProcedure: recipeProcedureTransformer.fetch(response.data),
    id: response.data.id,
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(recipeProcedureTransformer.fetch(errors));
};

export default (id, recipeProcedure) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/production/recipe_procedure/${id}`, recipeProcedureTransformer.send(recipeProcedure))
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeProcedure/update.js